import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'is',
  Pagination: {
    items_per_page: '/ síðu',
    jump_to: 'Síða',
    jump_to_confirm: 'staðfest',
    page: '',
    prev_page: 'Fyrri síða',
    next_page: 'Næsta síða',
    prev_5: 'Til baka 5 síður',
    next_5: 'Áfram 5 síður',
    prev_3: 'Til baka 3 síður',
    next_3: 'Áfram 3 síður',
  },
  DatePicker: {
    lang: {
      placeholder: 'Veldu dag',
      rangePlaceholder: [
        'Upphafsdagur',
        'Lokadagur',
      ],
      locale: 'is_IS',
      today: 'Í dag',
      now: 'Núna',
      backToToday: 'Til baka til dagsins í dag',
      ok: 'Í lagi',
      clear: 'Hreinsa',
      month: 'Mánuður',
      year: 'Ár',
      timeSelect: 'Velja tíma',
      dateSelect: 'Velja dag',
      monthSelect: 'Velja mánuð',
      yearSelect: 'Velja ár',
      decadeSelect: 'Velja áratug',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Fyrri mánuður (PageUp)',
      nextMonth: 'Næsti mánuður (PageDown)',
      previousYear: 'Fyrra ár (Control + left)',
      nextYear: 'Næsta ár (Control + right)',
      previousDecade: 'Fyrri áratugur',
      nextDecade: 'Næsti áratugur',
      previousCentury: 'Fyrri öld',
      nextCentury: 'Næsta öld',
    },
    timePickerLocale: {
      placeholder: 'Velja tíma',
    },
  },
  TimePicker: {
    placeholder: 'Velja tíma',
  },
  Calendar: {
    lang: {
      placeholder: 'Veldu dag',
      rangePlaceholder: [
        'Upphafsdagur',
        'Lokadagur',
      ],
      locale: 'is_IS',
      today: 'Í dag',
      now: 'Núna',
      backToToday: 'Til baka til dagsins í dag',
      ok: 'Í lagi',
      clear: 'Hreinsa',
      month: 'Mánuður',
      year: 'Ár',
      timeSelect: 'Velja tíma',
      dateSelect: 'Velja dag',
      monthSelect: 'Velja mánuð',
      yearSelect: 'Velja ár',
      decadeSelect: 'Velja áratug',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Fyrri mánuður (PageUp)',
      nextMonth: 'Næsti mánuður (PageDown)',
      previousYear: 'Fyrra ár (Control + left)',
      nextYear: 'Næsta ár (Control + right)',
      previousDecade: 'Fyrri áratugur',
      nextDecade: 'Næsti áratugur',
      previousCentury: 'Fyrri öld',
      nextCentury: 'Næsta öld',
    },
    timePickerLocale: {
      placeholder: 'Velja tíma',
    },
  },
  Table: {
    filterTitle: 'Afmarkanir',
    filterConfirm: 'Staðfesta',
    filterReset: 'Núllstilla',
    selectAll: 'Velja allt',
    selectInvert: 'Viðsnúa vali',
  },
  Modal: {
    okText: 'Áfram',
    cancelText: 'Hætta við',
    justOkText: 'Í lagi',
  },
  Popconfirm: {
    okText: 'Áfram',
    cancelText: 'Hætta við',
  },
  Transfer: {
    searchPlaceholder: 'Leita hér',
    itemUnit: 'færsla',
    itemsUnit: 'færslur',
  },
  Upload: {
    uploading: 'Hleð upp...',
    removeFile: 'Fjarlægja skrá',
    uploadError: 'Villa við að hlaða upp',
    previewFile: 'Forskoða skrá',
    downloadFile: 'Hlaða niður skrá',
  },
  Empty: {
    description: 'Engin gögn',
  },
};

export default localeValues;
